import { ChangeDetectionStrategy, Component, inject, type OnInit, signal } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'bng-login-callback',
  templateUrl: './login-callback.component.html',
  styleUrls: ['./login-callback.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginCallbackComponent implements OnInit {
  private _authService = inject(AuthService);
  private _router = inject(Router);

  error = signal<string | null>(null);

  ngOnInit() {
    /**
     * Handles the response from Okta and parses tokens.
     */
    this._authService.handleRedirect().catch((err) => {
      if (err.errorCode === 'access_denied') {
        this._router.navigate(['/account-link']);
        return;
      }

      this.error.set(err.toString());
    });
  }

  handleClickHere() {
    this._authService.loginRedirect().catch((err) => {
      this.error.set(err.toString());
    });
  }
}
